import gql from 'graphql-tag'

export default gql`
  mutation cancelSubscription {
    cancelSubscription {
      success
      message
    }
  }
`
